import type { SvgType } from './types'

export default function ClockIn({
  fill = 'currentColor',
  style,
  size,
  viewBox
}: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7499_56700)">
        <path
          d="M6.52107 6.64859C7.98407 6.64859 9.17007 5.46259 9.17007 3.99959C9.17007 2.53658 7.98407 1.35059 6.52107 1.35059C5.05807 1.35059 3.87207 2.53658 3.87207 3.99959C3.87207 5.46259 5.05807 6.64859 6.52107 6.64859Z"
          stroke={fill}
          strokeWidth="1.17439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.92804 9.0293C2.89976 9.68558 1.40229 11.5182 1.23389 13.7231H6.57906"
          stroke={fill}
          strokeWidth="1.17439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4943 13.7123C12.2011 13.7123 13.5848 12.3286 13.5848 10.6218C13.5848 8.91491 12.2011 7.53125 10.4943 7.53125C8.78747 7.53125 7.40381 8.91491 7.40381 10.6218C7.40381 12.3286 8.78747 13.7123 10.4943 13.7123Z"
          stroke={fill}
          strokeWidth="1.17439"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0527 9.29785V10.5341L11.2889 11.3582"
          stroke={fill}
          strokeWidth="1.0961"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7499_56700">
          <rect
            width="14.128"
            height="14.128"
            fill="white"
            transform="translate(0.339844 0.467773)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
